import { DOCUMENT_TYPE } from '@mos-front-components/public/es/components/Passport';

export const PERMITTED_DOCUMENTS_PASSPORT_RF = [DOCUMENT_TYPE.PASSPORT_RF];
export const PERMITTED_DOCUMENTS_MILITARY_ID = [DOCUMENT_TYPE.MILITARY_ID];
const BIRTH_CERTIFICATE_INTERNATIONAL = 'BIRTH_CERTIFICATE_INTERNATIONAL';

const {
  PASSPORT_RF,
  FOREIGN_PASSPORT,
  RESIDENCE,
  REFUGEE_ID,
  TEMPORARY_ID,
  TEMPORARY_RESIDENT_PERMIT,
  INTERNATIONAL_PASSPORT_RF,
  MILITARY_ID,
  DIPLOMATIC_PASSPORT,
  SERVICE_PASSPORT,
  RF_NON_CITIZEN_DOC,
  TEMPORARY_REFUGEE_PERMIT,
  OFFICER_ID,
  FOREIGN_NON_CITIZEN_DOC,
  REFUGEE_CONSIDERATION,
  BIRTH_CERTIFICATE_RF
} = DOCUMENT_TYPE;

export const MAPPED_DOCUMENTS = {
  PASSPORT_RF,
  INTERNATIONAL_PASSPORT_RF,
  DIPLOMATIC_PASSPORT,
  SERVICE_PASSPORT,
  MILITARY_ID,
  TEMPORARY_ID,
  FOREIGN_PASSPORT,
  TEMPORARY_RESIDENT_PERMIT,
  RESIDENCE,
  RF_NON_CITIZEN_DOC,
  REFUGEE_ID,
  TEMPORARY_REFUGEE_PERMIT,
  OFFICER_ID,
  FOREIGN_NON_CITIZEN_DOC,
  REFUGEE_CONSIDERATION,
  BIRTH_CERTIFICATE_RF,
  BIRTH_CERTIFICATE_INTERNATIONAL
};

export const DOCUMENT_TITLES = {
  [PASSPORT_RF]: 'Паспорт гражданина РФ',
  [INTERNATIONAL_PASSPORT_RF]: 'Загранпаспорт гражданина РФ',
  [TEMPORARY_ID]:
    'Временное удостоверение личности гражданина РФ (по форме N 2П)',
  [FOREIGN_PASSPORT]: 'Паспорт иностранного гражданина',
  [REFUGEE_ID]: 'Удостоверение беженца',
  [TEMPORARY_RESIDENT_PERMIT]: 'Разрешение на временное проживание',
  [RESIDENCE]: 'Вид на жительство',
  [DIPLOMATIC_PASSPORT]: 'Дипломатический паспорт',
  [SERVICE_PASSPORT]: 'Служебный паспорт',
  [MILITARY_ID]: 'Военный билет',
  [FOREIGN_NON_CITIZEN_DOC]:
    'Документ, выданный иностранным государством и признаваемый в соответствии с международным договором РФ в качестве документа, удостоверяющего личность лица без гражданства',
  [RF_NON_CITIZEN_DOC]:
    'Документ, удостоверяющий личность на период рассмотрения заявления о признании гражданином РФ или о приеме в гражданство РФ',
  [REFUGEE_CONSIDERATION]:
    'Свидетельство о рассмотрении ходатайства о признании беженцем на территории РФ по существу',
  [TEMPORARY_REFUGEE_PERMIT]:
    'Свидетельство о предоставлении временного убежища на территории РФ',
  [BIRTH_CERTIFICATE_RF]: 'Свидетельство о рождении РФ',
  [BIRTH_CERTIFICATE_INTERNATIONAL]:
    'Свидетельство о рождении иностранного образца',
  [OFFICER_ID]: 'Удостоверение личности военнослужащего РФ'
};

export const PERMITTED_DOCUMENTS_FOR_ADULT = {
  PASSPORT_RF: 'PASSPORT_RF',
  TEMPORARY_ID: 'TEMPORARY_ID',
  DIPLOMATIC_PASSPORT: 'DIPLOMATIC_PASSPORT',
  SERVICE_PASSPORT: 'SERVICE_PASSPORT',
  MILITARY_ID: 'MILITARY_ID',
  OFFICER_ID: 'OFFICER_ID',
  FOREIGN_PASSPORT: 'FOREIGN_PASSPORT',
  REFUGEE_ID: 'REFUGEE_ID',
  TEMPORARY_REFUGEE_PERMIT: 'TEMPORARY_REFUGEE_PERMIT',
  TEMPORARY_RESIDENT_PERMIT: 'TEMPORARY_RESIDENT_PERMIT',
  RESIDENCE: 'RESIDENCE',
  FOREIGN_NON_CITIZEN_DOC: 'FOREIGN_NON_CITIZEN_DOC',
  RF_NON_CITIZEN_DOC: 'RF_NON_CITIZEN_DOC',
  REFUGEE_CONSIDERATION: 'REFUGEE_CONSIDERATION'
};

export const PERMITTED_DOCUMENTS = {
  ...PERMITTED_DOCUMENTS_FOR_ADULT,
  BIRTH_CERTIFICATE_RF: 'BIRTH_CERTIFICATE_RF',
  BIRTH_CERTIFICATE_INTERNATIONAL: 'BIRTH_CERTIFICATE_INTERNATIONAL'
};

export const PERMITTED_DOCUMENTS_MAPPED = Object.keys(
  PERMITTED_DOCUMENTS_FOR_ADULT
);

export const PERMITTED_DOCUMENTS_FOR_CHILD = [
  PERMITTED_DOCUMENTS.BIRTH_CERTIFICATE_RF,
  PERMITTED_DOCUMENTS.BIRTH_CERTIFICATE_INTERNATIONAL
];

export const PERMITTED_DOCUMENTS_OTHERS = [
  PERMITTED_DOCUMENTS.BIRTH_CERTIFICATE_RF,
  PERMITTED_DOCUMENTS.BIRTH_CERTIFICATE_INTERNATIONAL,
  PERMITTED_DOCUMENTS.PASSPORT_RF,
  PERMITTED_DOCUMENTS.INTERNATIONAL_PASSPORT_RF,
  PERMITTED_DOCUMENTS.TEMPORARY_ID,
  PERMITTED_DOCUMENTS.DIPLOMATIC_PASSPORT,
  PERMITTED_DOCUMENTS.SERVICE_PASSPORT,
  PERMITTED_DOCUMENTS.MILITARY_ID,
  PERMITTED_DOCUMENTS.OFFICER_ID,
  PERMITTED_DOCUMENTS.FOREIGN_PASSPORT,
  PERMITTED_DOCUMENTS.REFUGEE_ID,
  PERMITTED_DOCUMENTS.TEMPORARY_REFUGEE_PERMIT,
  PERMITTED_DOCUMENTS.TEMPORARY_RESIDENT_PERMIT,
  PERMITTED_DOCUMENTS.RESIDENCE,
  PERMITTED_DOCUMENTS.FOREIGN_NON_CITIZEN_DOC,
  PERMITTED_DOCUMENTS.RF_NON_CITIZEN_DOC,
  PERMITTED_DOCUMENTS.REFUGEE_CONSIDERATION
];

export const PERMITTED_DOCUMENTS_NOT_PASSPORT = {
  INTERNATIONAL_PASSPORT_RF: 'INTERNATIONAL_PASSPORT_RF',
  TEMPORARY_ID: 'TEMPORARY_ID',
  DIPLOMATIC_PASSPORT: 'DIPLOMATIC_PASSPORT',
  SERVICE_PASSPORT: 'SERVICE_PASSPORT',
  MILITARY_ID: 'MILITARY_ID',
  OFFICER_ID: 'OFFICER_ID',
  FOREIGN_PASSPORT: 'FOREIGN_PASSPORT',
  REFUGEE_ID: 'REFUGEE_ID',
  TEMPORARY_REFUGEE_PERMIT: 'TEMPORARY_REFUGEE_PERMIT',
  TEMPORARY_RESIDENT_PERMIT: 'TEMPORARY_RESIDENT_PERMIT',
  RESIDENCE: 'RESIDENCE',
  FOREIGN_NON_CITIZEN_DOC: 'FOREIGN_NON_CITIZEN_DOC',
  RF_NON_CITIZEN_DOC: 'RF_NON_CITIZEN_DOC',
  REFUGEE_CONSIDERATION: 'REFUGEE_CONSIDERATION',
  BIRTH_CERTIFICATE_RF: 'BIRTH_CERTIFICATE_RF',
  BIRTH_CERTIFICATE_INTERNATIONAL: 'BIRTH_CERTIFICATE_INTERNATIONAL'
};
